import React from 'react';

const BS_Editor = () => {
    return (
        <div>
            <h1>BS_Editor Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Editor;
